import { removeEmptyValues } from '~/utils';

export function pickActiveFilters(
	filters: Record<string, unknown> | null | undefined
): Record<string, unknown> {
	if (!filters) return {};

	return removeEmptyValues(filters);
}
